import {ReactNode} from 'react';
import {view} from '@sail/ui/deprecated';
import type {InlineDataProps} from '@stripe-internal/inline-data';
import {InlineDataComponent} from '@stripe-internal/inline-data';
import {ChatRow} from './ChatRow';
import {ChatBubble} from './ChatBubble';

export type Props = {
  inlineData: InlineDataProps;
  position?: 'start' | 'end';
  style?: 'bubble' | 'outer_bubble' | 'none';
  avatar?: ReactNode | null | undefined;
  background?: 'neutral100' | 'neutral600';
  error?: ReactNode;
  children?: ReactNode;
};

export const InlineDataRow = ({
  inlineData,
  style = 'bubble',
  position,
  avatar,
  background = 'neutral100',
  error,
  children,
}: Props) => {
  let component;
  switch (style) {
    case 'bubble':
      component = (
        <ChatRow avatar={avatar} position={position} error={error}>
          <ChatBubble background={background}>
            <InlineDataComponent {...inlineData} />
            {children}
          </ChatBubble>
        </ChatRow>
      );
      break;
    case 'outer_bubble':
      component = (
        <ChatRow avatar={avatar} position={position} error={error}>
          <InlineDataComponent {...inlineData} />
          {children}
        </ChatRow>
      );
      break;
    case 'none':
    default:
      component = (
        <>
          <InlineDataComponent {...inlineData} />
          {children}
        </>
      );
  }

  return <view.div data-testid="inline-data-row">{component}</view.div>;
};
